<template>
  <div
    id="app"
    v-hb-loading.fullscreen.lock="isLoading"
    hb-loading-bg="#014C6D"
    hb-loading-circle-bg="rgba(255, 255, 255, 0.3)"
    hb-loading-color="#DADDE0"
    v-report.visit
  >
    <div class="container" v-if="!isLoading">
      <cpt-nav v-if="showNav" logoColor="#FFF" bg="#014C6D"></cpt-nav>

      <cpt-list-header
        :title="'幻兽帕鲁图鉴'"
        :desc="'点击帕鲁条目查看详细数据'"
      ></cpt-list-header>
      <div class="cpt-search-row">
        <div class="search-input">
          <svg
            t="1686280930399"
            class="icon-search"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2339"
            width="200"
            height="200"
          >
            <path
              d="M760.682667 821.034667A424.896 424.896 0 0 1 490.666667 917.333333C255.018667 917.333333 64 726.314667 64 490.666667S255.018667 64 490.666667 64s426.666667 191.018667 426.666666 426.666667c0 102.464-36.117333 196.48-96.298666 270.016l137.088 137.109333a42.666667 42.666667 0 1 1-60.330667 60.330667l-137.109333-137.088zM490.666667 832c188.522667 0 341.333333-152.810667 341.333333-341.333333S679.189333 149.333333 490.666667 149.333333 149.333333 302.144 149.333333 490.666667s152.810667 341.333333 341.333334 341.333333z"
              p-id="2340"
            ></path>
          </svg>
          <form action="" class="filter-form" @submit.prevent>
            <input
              ref="search-input"
              class="input"
              v-model="search_input"
              @blur="handleChangeSearch"
              @keyup="searchLink"
              type="text"
              placeholder="输入搜索内容"
            />
          </form>
        </div>
        <div
          class="modal-btn"
          :class="{ active: active_element }"
          @click="show_property_modal = true"
        >
          <div class="label">属性</div>
          <hb-icon common-arrow-down-filled></hb-icon>
        </div>
        <div
          class="modal-btn"
          :class="{ active: active_skill_list.length }"
          @click="show_skill_modal = true"
        >
          <div class="label">基建技能</div>
          <hb-icon common-arrow-down-filled></hb-icon>
        </div>
      </div>

      <cpt-pal-list
        :header_list="tab_header_list"
        :pal_list="pal_list"
        :navHeight="navHeight"
        :active_tab="sort_key"
        :is_desc="is_desc"
        :page_loading="page_loading"
        :show_nav="showNav"
        @need_load="getData"
        @change_seq="handleChangeSeq"
      ></cpt-pal-list>

      <cpt-footer></cpt-footer>
    </div>
    <!-- 属性筛选 -->
    <hb-modal :visible.sync="show_property_modal" title="属性" :lock="true">
      <template>
        <div class="option-list">
          <div
            class="option"
            :class="{ active: option.key == active_element }"
            v-for="option in element_filter_list"
            :key="option.key"
            @click="handleSelectElement(option)"
          >
            <img class="icon" v-if="option.icon" v-src="option.icon" />
            <div class="label">{{ option.name }}</div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="cancel-btn" @click="show_property_modal = false">取消</div>
      </template>
    </hb-modal>
    <!-- 基建技能多选 -->
    <hb-modal :visible.sync="show_skill_modal" title="基建技能" :lock="true">
      <template>
        <div class="option-list">
          <div
            class="option"
            :class="{ active: option.active }"
            v-for="option in build_skill_list"
            :key="option.key"
            @click="handleSelectSkill(option)"
          >
            <img class="icon" v-if="option.icon" v-src="option.icon" />
            <div class="label">{{ option.name }}</div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <hb-button
          class="cancel-btn"
          size="large"
          text="取消"
          @click="cancelSkillModal"
        ></hb-button>
        <hb-button
          class="confirm-btn"
          type="primary"
          size="large"
          text="确定"
          @click="confirmSkillModal"
        ></hb-button>
      </template>
    </hb-modal>

    <cpt-rotate-bg
      bg="https://imgheybox.max-c.com/oa/2024/03/18/3f7da89c6d8db98115d5151894cee538.png"
    ></cpt-rotate-bg>
  </div>
</template>
<script>
import CptNav from '_com/base/page-nav/index.vue';
import CptRotateBg from '../../components/cpt-rotate-bg.vue';
import CptFooter from '../components/cpt-footer.vue';
import CptListHeader from '../components/cpt-list-header.vue';
import CptPalList from './components/cpt-pal-list.vue';
import {
  getUrlParam,
  getParams,
  executeProtocol,
  executeProtocolSync,
  registerNativeCallback,
  deepCopy,
} from '_lib/utils';
import { getPalList } from '_api/game/palworld/database';

export default {
  components: {
    CptNav,
    CptRotateBg,
    CptFooter,
    CptListHeader,
    CptPalList,
  },
  data() {
    return {
      showNav: getUrlParam('source') != 'tab',
      navHeight: executeProtocolSync({
        protocol_type: 'getNavigationBarHeight',
      }),
      isLoading: true,

      querys: {},

      //搜索筛选相关参数
      search_input: '',
      active_element: '',
      active_skill_list: [],
      temp_skill_list: [],

      show_property_modal: false,
      show_skill_modal: false,
      list_loading: false, //整个列表加载
      page_loading: false, //分页加载
      loading_height: 400,
      sort_key: '',
      is_desc: true,

      limit: 30,
      nomore: false,
      load_lock: false,

      //筛选器列表
      element_filter_list: [],
      build_skill_list: [],

      //表相关
      tab_header_list: [],
      pal_list: [],
    };
  },
  created() {
    this.querys = getParams();
    this.loading_height =
      (window.innerHeight / 2 - this.navHeight - 90 - 32) * 2;
    this.getData().then(() => {
      this.isLoading = false;
    });
  },

  mounted() {
    registerNativeCallback('pageHiddenToOthersPage', () => {});
    registerNativeCallback('pageVisibleToOthersPage', () => {});
  },

  methods: {
    async getData(is_init = false) {
      if ((!is_init && this.nomore) || this.load_lock) {
        console.log('there is nomore');
        return;
      }
      this.load_lock = true;
      if (is_init) {
        this.list_loading = true;
        this.nomore = false;
      } else {
        this.page_loading = true;
      }
      //生成参数
      let params = {
        offset: is_init ? 0 : this.pal_list.length,
        limit: this.limit,
        element_key: this.active_element ? this.active_element : undefined,
        q: this.search_input ? this.search_input : undefined,
        sort_key: this.sort_key ? this.sort_key : undefined,
        sort_direction: this.is_desc ? 1 : 0,
      };
      if (this.active_skill_list.length) {
        params.build_key = this.active_skill_list.map((o) => o.key).join(',');
      }
      //请求
      let res = await getPalList(params);
      let { result, status } = res.data;
      if (status == 'ok') {
        this.tab_header_list = result.tabs || [];
        if (result.pal_infos.length < this.limit) {
          this.nomore = true;
        }
        if (is_init) {
          this.pal_list = result.pal_infos || [];
        } else {
          this.pal_list = this.pal_list.concat(result.pal_infos || []);
        }
        //初始化筛选器
        if (!this.element_filter_list.length) {
          this.element_filter_list = result.element_filter || [];
        }
        if (!this.build_skill_list.length) {
          this.build_skill_list = result.build_filter || [];
        }
      }
      this.list_loading = false;
      this.page_loading = false;
      this.load_lock = false;
    },
    handleChangeSearch() {
      this.getData(true);
    },
    handleChangeSeq(key, is_desc) {
      this.sort_key = key;
      this.is_desc = is_desc;
      this.getData(true);
    },
    searchLink(e) {
      if (e.keyCode == 13) {
        this.$refs['search-input'].blur();
      }
    },
    handleSelectElement(option) {
      if (option.key == this.active_element) {
        this.active_element = '';
      } else {
        this.active_element = option.key;
      }
      this.getData(true).then(() => {
        this.show_property_modal = false;
      });
      executeProtocol({
        protocol_type: 'trackData',
        type: '4',
        path: '/web/game/palworld/database/pal_list/filter',
        addition: {
          type: 'element',
        },
      });
    },
    handleSelectSkill(option) {
      let exist_index = this.temp_skill_list.findIndex(
        (o) => o.key == option.key,
      );
      if (exist_index == -1) {
        //添加新技能
        this.$set(option, 'active', 1);
        this.temp_skill_list.push(option);
      } else {
        //除去已选技能
        this.$set(option, 'active', 0);
        this.temp_skill_list.splice(exist_index, 1);
      }
    },
    confirmSkillModal() {
      this.active_skill_list = deepCopy(this.temp_skill_list);
      this.show_skill_modal = false;
      executeProtocol({
        protocol_type: 'trackData',
        type: '4',
        path: '/web/game/palworld/database/pal_list/filter',
        addition: {
          type: 'skill',
        },
      });
      this.getData(true);
    },
    cancelSkillModal() {
      this.temp_skill_list = [];
      this.build_skill_list.forEach((o) => {
        let exist_key = this.active_skill_list.findIndex(
          (active_o) => o.key == active_o.key,
        );
        if (exist_key != -1) {
          this.$set(o, 'active', 1);
          this.temp_skill_list.push(o);
        } else {
          this.$set(o, 'active', 0);
        }
      });
      this.show_skill_modal = false;
    },
  },
};
</script>
<style lang="less">
@import '~_style/common.css';
html,
body {
  background: transparent !important;
  overscroll-behavior: none;
}

#app {
  margin: 0 auto;
  max-width: 480px;
  min-height: 100vh;
  overflow: hidden;
  color: #fff;

  .hb-modal {
    background: #014c6d;
    color: #fff;
    .hb-modal__title {
      color: rgba(255, 255, 255, 0.7);
      font-size: 13px;
      font-weight: 400;
      line-height: 34px;
      height: 34px;
    }
    .hb-modal__body {
      padding: 0;
    }
    .cancel-btn {
      width: 100%;
      height: 44px;
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.1);
      line-height: 44px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
    }
    .confirm-btn {
      border-radius: 5px;
      background: linear-gradient(45deg, #00b7c5 0%, #008195 100%), #fff;
    }
    .hb-button {
      &::before {
        display: none;
      }
    }
  }
  .option-list {
    padding: 0 12px;
    display: flex;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .option {
      width: calc((100% - 10px) / 3);
      height: 30px;
      border-radius: 3px;
      background: rgba(255, 255, 255, 0.03);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: 0 5px 5px 0;
      &:nth-child(3n) {
        margin: 0 0 5px 0;
      }
      &.active {
        background: rgba(255, 255, 255, 0.1);
        .label {
          color: #fff;
        }
      }
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
      .label {
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      }
    }
  }
}

.container {
  min-height: 100vh;
  position: relative;
  z-index: 1;
  padding-bottom: 58px;
  .cpt-search-row {
    height: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    .search-input {
      flex: 1;
      width: 0;
      height: 30px;
      z-index: 3;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 0.5px solid rgba(255, 255, 255, 0.1);
      background: rgba(255, 255, 255, 0.05);
      overflow: hidden;
      .filter-form {
        flex: 1;

        .input {
          width: 100%;
          height: 30px;
          padding-right: 8px;
          border: none;
          background: transparent;
          z-index: 999;
          color: #fff;
          font-weight: 400;
          font-size: 13px;
          &::placeholder {
            color: rgba(255, 255, 255, 0.4);
          }
        }
      }
      .icon-search {
        width: 16px;
        height: 16px;
        margin: 0 8px;
        flex-shrink: 0;
        z-index: 1000;
        path {
          fill: rgba(255, 255, 255, 0.6);
        }
      }
    }
    .modal-btn {
      margin-left: 15px;
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 0.7);
      &.active {
        color: #fff;
      }
      .label {
        font-size: 12px;
        font-weight: 400;
      }
      i {
        font-size: 10px;
        transform: scale(0.8);
        margin-left: 1px;
      }
    }
  }
  .loading-block {
    width: 100%;
    height: calc(100vh - 90px - 32px);
  }
}
</style>
